export default {
  txz: 'ສະຖານີເອົາຕູ້',//提箱站
  ggcs:'ຂະໜາດມາໃຫ້ສັງເກດ',//规格参数
  ckg:'ຄວາມກວ້າງແລະລວງສູງ',//长宽高
  zztj:'ຂະໜາດບໍລິມາດ',//载重体积
  zzlck:'ປະມານການໂຫຼດສີນຄ້າ',//装载量参考
  txrq:'ວັນທີ່ເອົາຕູ້ອອກ',//提箱日期
  syxs:'ໂຕເລືອກທີ່ຍ່າຍຢູ່',//可用箱数
  qkxzy:'ແຫ້ມີຈຳນວຍຄວາມສະດວກ',//取空箱资源
  xs:'ຈໍານວນຕູ້',//箱数
}
